export default __webpack_public_path__ + "images/V4.dd17e59.png";